import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type AttachTemplateToMessageMutationVariables = Types.Exact<{
  messageId: Types.Scalars['Int']
  templateId: Types.Scalars['Int']
}>

export type AttachTemplateToMessageMutation = {
  __typename?: 'Mutation'
  attachTemplateToMessage: {
    __typename?: 'MessageHasTemplate'
    emailTemplate: { __typename?: 'EmailTemplate'; id: number }
    message: { __typename?: 'Message'; id: number }
  }
}

export const AttachTemplateToMessageDocument = gql`
  mutation AttachTemplateToMessage($messageId: Int!, $templateId: Int!) {
    attachTemplateToMessage(messageId: $messageId, templateId: $templateId) {
      emailTemplate {
        id
      }
      message {
        id
      }
    }
  }
`
export type AttachTemplateToMessageMutationFn = ApolloReactCommon.MutationFunction<
  AttachTemplateToMessageMutation,
  AttachTemplateToMessageMutationVariables
>
export function useAttachTemplateToMessageMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AttachTemplateToMessageMutation,
    AttachTemplateToMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    AttachTemplateToMessageMutation,
    AttachTemplateToMessageMutationVariables
  >(AttachTemplateToMessageDocument, options)
}
export type AttachTemplateToMessageMutationHookResult = ReturnType<
  typeof useAttachTemplateToMessageMutation
>
export type AttachTemplateToMessageMutationResult =
  ApolloReactCommon.MutationResult<AttachTemplateToMessageMutation>
export type AttachTemplateToMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AttachTemplateToMessageMutation,
  AttachTemplateToMessageMutationVariables
>
